import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError, of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalVersionService {
  constructor(private http: HttpClient) { }

  getCommit(): Observable<string> {
    const url = 'assets/version/version.json?';
    return this.http.get<{ commit: string }>(url).pipe(
      map(resp => {
        return resp.commit || 'unknown';
      }),
      catchError(error => {
        console.error('Failed to load version.json:', error);
        return of('unknown');
      })
    );
  }
}
